class DFIS {
    constructor(
        permissionId,
        segmentId, 
        elementId,
        id,
        requiredPin,
        requiredCacheo,
        requiredPassBack,
        porcentCacheo,
        name,
        alias,
        description
    ) {
        this.permissionId = permissionId;
        this.segmentId = segmentId;
        this.elementId = elementId;
        this.id = id;
        this.requiredPin = requiredPin;
        this.requiredPinIcon = DFIS.getIconForRequirement(this.requiredPin);
        this.requiredCacheo = requiredCacheo;
        this.requiredCacheoIcon = DFIS.getIconForRequirement(this.requiredCacheo);
        this.requiredPassBack = requiredPassBack;
        this.requiredPassBackIcon = DFIS.getIconForRequirement(this.requiredPassBack);
        this.porcentCacheo = porcentCacheo;
        this.name = name;
        this.alias = alias;
        this.description = description;
        this.subtitle= this.alias
    }

    static fromJson({
        permisoId,
        segmId,
        elemId,
        dfiId,
        reqPin,
        reqCacheo,
        reqPassBack,
        porcenCacheo,
        dfiNombre,
        dfiAlias,
        dfiDescripcion
    }) {
        return new DFIS(
        permisoId,
        segmId,
        elemId,
        dfiId,
        reqPin,
        reqCacheo,
        reqPassBack,
        porcenCacheo,
        dfiNombre,
        dfiAlias,
        dfiDescripcion
        );
    }
    static getIconForRequirement(value) {
        switch (value) {
            case 0:
                return '❌'; // No
            case 1:
                return '✅'; // Sí
            case 2:
                return '➖'; // No definido (alternativa)
            default:
                return '➖'; // Por si acaso
        }
    }
}

export default DFIS;
